import { memo } from 'react';
import { useSelector } from 'react-redux';
import { itemSettingStyle, noteInline, isNoteUnderLine } from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const RehabItem = ({ rehabItems, removeData, type, isHistoryPage }) => {
  const prescriptionItems = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.prescriptionItems,
  );
  return (
    <>
      {rehabItems?.map((item, index) => {
        return (
          <li key={index}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span
                style={itemSettingStyle(
                  prescriptionItems?.items?.rehabilitation?.itemStyle || {},
                )}
              >
                {item?.name}{' '}
                {item?.duration !== ''
                  ? '- ' + item?.duration + ' ' + item?.unit
                  : ''}
                {noteInline(item.note, 'rehabilitation', prescriptionItems)}
              </span>
              {!isHistoryPage && (
                <ChiefComplainDeleteBtn
                  action={removeData}
                  itemName={type}
                  delId={item.name}
                />
              )}
              {/* {removeData && (
                <span
                  className="float-right cursor-pointer"
                  onClick={() => removeData(type, item.name)}
                >
                  <i
                    className="far fa-times-circle"
                    style={{ color: '#CB2020D9' }}
                  ></i>
                </span>
              )} */}
            </div>
            {item.note && isNoteUnderLine('rehabilitation', prescriptionItems) ? (
              <div
                className="pl-2 preline"
                style={itemSettingStyle(
                  prescriptionItems?.items?.rehabilitation?.subItemStyle || {},
                )}
              >
                {item?.note}
              </div>
            ) : (
              ''
            )}
          </li>
        );
      })}
    </>
  );
};

export default memo(RehabItem);
